import { useCallback, useEffect, useRef, useState } from 'react';
import copy from 'copy-to-clipboard';

const COPIED_MS = 1600;

/** Copies a text and tells for a moment that it did, so a button can read "Copied". */
export function useCopyFlag(text: string): { copied: boolean; copyText: () => void } {
  const [copied, setCopied] = useState(false);
  const timeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(
    () => () => {
      if (timeout.current !== null) {
        clearTimeout(timeout.current);
      }
    },
    []
  );

  const copyText = useCallback(() => {
    copy(text);
    setCopied(true);
    if (timeout.current !== null) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => setCopied(false), COPIED_MS);
  }, [text]);

  return { copied, copyText };
}
